import { Dialog } from '@/components/UI/Dialog'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  /** 再撮影ボタン押下 */
  onRetry: () => void
  /** 補填申請ボタン押下 */
  onApply: () => void
  /** 閉じるボタン押下 */
  onClose: () => void
  scrollLock?: boolean
}

/**
 * OCR 読み取り失敗ダイアログ
 * スタンプ獲得のため OCR で撮影した画像が読み取れなかった場合に表示する。
 */
export const DialogOcrReadFailure = memo(({ onRetry, onApply, onClose, scrollLock = false }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog
      selectorState={true}
      compact
      showCloseButton={true}
      lockScroll={scrollLock}
      closeAction={onClose}
      title={t('spot_detail.ocr.failure.title', 'OCR読み取り失敗')}
    >
      <p className="text-center text-sm text-gray-700 mt-2 mb-6">
        {t(
          'spot_detail.ocr.failure.message',
          '画像を読み取ることができませんでした。再度お試しいただくか、補填申請を行ってください。',
        )}
      </p>
      <div className="flex flex-col gap-3 px-4 pb-4">
        <button
          type="button"
          onClick={onRetry}
          className="w-full rounded-full bg-primary py-3 text-center text-sm font-bold text-white"
        >
          {t('spot_detail.ocr.failure.retry', '再撮影する')}
        </button>
        <button
          type="button"
          onClick={onApply}
          className="w-full rounded-full border border-primary py-3 text-center text-sm font-bold text-primary"
        >
          {t('spot_detail.ocr.failure.apply', '補填申請をする')}
        </button>
      </div>
    </Dialog>
  )
})

DialogOcrReadFailure.displayName = 'DialogOcrReadFailure'
